export default __webpack_public_path__ + "static/media/add-modal.52a84732.svg";